import React, { useEffect, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import axios from "axios";
import {
  Box,
  Button,
  Divider,
  IconButton,
  AppBar,
  Toolbar,
  Paper,
  Drawer,
  List,
  ListItem,
  Typography,
  Grid,
  ListItemButton,
} from "@mui/material";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";
import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import TextAlign from "@tiptap/extension-text-align";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import Close from "@mui/icons-material/Close";
import logo from "../../_assets/images/jklogo.png";
import CommentDialogBox from "./CommentDialodBox";
// import './Editor.css'; // Custom CSS for highlighting
import AddCommentIcon from '@mui/icons-material/AddComment';
import io from 'socket.io-client';
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Highlight } from '@tiptap/extension-highlight';



const drawerWidth = 340;


const Agreement = () => {

   let socket;
 
   const { documentId } = useParams();

   const history = useHistory();

  const [fetchcomment, setfetchcomment] = useState(false)
  const [open, setOpen] = useState(false);
  const [changesopen, setchangesopen] = useState(false)
  const [changes, setchanges] = useState([])
  const [content, setcontent] = useState("");
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [selectedText, setSelectedText] = useState("nothingselected");
  const [role, setrole] = useState("jk");
  const [allComments, setAllComments] = useState([]);
  const [highlightedLine, setHighlightedLine] = useState('');
  const [agreementid, setagreementid] = useState('')


  const highlightExtension = Highlight.configure({
    HTMLAttributes: {
      class: 'custom-highlight',
    },
  });

  
  const editor = useEditor({
    extensions: [
      StarterKit, 
      {
        marks: {
          highlight: {
            // Use a class for styling
            class: 'custom-highlight',
          },
        }, 
      },
      Bold,
      Italic,
      Underline,
      BulletList.configure({ ordered: false }),
      OrderedList,
      TextAlign,
      highlightExtension
    ],
    content: content,
    onUpdate({ editor }) {
      setcontent(editor.getHTML());
    },
  });

 
  Highlight.configure({
    HTMLAttributes: {
      class: 'custom-highlight',
    },
  });

  const fetchAgreement = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
     try {
      console.log('documentidddd',documentId);
       const response = await axios.get(
         `http://localhost:8028/api/v1/actyv/getagreement/${documentId}`,
         {
           headers: { Authorization: `Bearer ${token}`},
         }
       );
       const fetchedContent = response.data.Agreement;
       console.log(response.data);
       setcontent(fetchedContent);
       setagreementid(response.data.dealerId)
     
     } catch (error) {
       console.error("Error fetching agreement content:", error);
     }
   };

   useEffect(() => {
     editor?.commands.setContent(content)  
   }, [content])
   

  useEffect(() => {
    socket = io('http://localhost:8028'); 

    socket.emit('setup',documentId)

    socket.on('comments updated',(newfetchcomment)=>{
      console.log('comments updated');
      fetchComments();

    })
  }, [])



  useEffect(async () => {
    fetchAgreement();
  }, []);



  const handleDrawerOpen = () => {
    setOpen(!open);
    fetchComments();
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const fetchComments = () => {
    const token = localStorage.getItem("token");

    axios
      .get(`http://localhost:8028/api/v1/actyv/fetchcomments/${agreementid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log('comments',response.data);
        setAllComments(response.data);
      });
  };

  const fetchchanges = () => {
    const token = localStorage.getItem("token");

    axios
      .get(`http://localhost:8028/api/v1/actyv/fetchchanges/${agreementid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log('changes',response.data);
        if (response.data.changes) {
          setchanges(response.data.changes);

        }

      });
  };

  const saveContent = () => {
    const token = localStorage.getItem("token");
    const updatedContent = editor.getHTML();

    axios
      .post(
        "http://localhost:8028/api/v1/actyv/savechanges",
        { documentId: agreementid,
          editedagreement: updatedContent },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
           console.log(response.data);
      });
  };

  const addComment = () => {
    if (!editor) return;
    const { from, to } = editor.state.selection;
    const selected = editor.state.doc.textBetween(from, to, " ");
    setSelectedText(selected);
    setOpenCommentDialog(true);
  };



  const highlightLine = (lineContent) => {
    if (editor) {
      const { state, view } = editor;
      const { from, to } = state.selection;

      // You can use a transaction to find and highlight the specific line content
      const tr = state.tr;

      // Find the start and end positions of the lineContent
      state.doc.descendants((node, pos) => {
        if (node.isTextblock && node.textContent.includes(lineContent)) {
          const start = pos + node.textContent.indexOf(lineContent);
          const end = start + lineContent.length;
          
          tr.addMark(start, end, state.schema.marks.highlight.create({ class: 'custom-highlight' }));
        }
      });

      view.dispatch(tr);
    }
  };
  

  if (!editor) {
    return null;
  }

  return (
    <Box sx={{ display: "flex",width:'100%', height: "100vh" }}>
      <Box sx={{ flexGrow: 1, display: "flex",width:'100%', flexDirection: "column" }}>
        <AppBar position="static" color="default">
          <Toolbar>
            <Box sx={{ display: "flex", flexGrow: 1 }}>
              <Box sx={{ height: 6, ml: -7, mr: -6, mt: -1 }}>
                <Box>
                  <svg
                    width="150"
                    height="50"
                    viewBox="0 0 180 180"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M152 90C152 124.242 124.242 152 90 152C55.7583 152 28 124.242 28 90C28 55.7583 55.7583 28 90 28C124.242 28 152 55.7583 152 90Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M64.4098 70L54.45 89.4244C54.45 89.4244 52.0028 93.7186 47.7912 93.8475C43.5796 93.9763 39.7949 93.8475 39.7949 93.8475L35 103.996H54.2224C54.2224 103.996 62.1191 104.44 67.4831 95.694C72.8472 86.948 81 70.3579 81 70.3579L64.4098 70Z"
                      fill="#231F20"
                    ></path>
                    <path
                      d="M85.092 70H102L97.4119 80.7941L87.1312 86.3629L91.7193 91.4021L85.092 104H68L85.092 70Z"
                      fill="#231F20"
                    ></path>
                    <path
                      d="M89 87.3457L119.718 71H145L127.82 81.2564L137.371 81.3265L132.136 91.7092H116.477L129.914 104H108.044L89 87.3457Z"
                      fill="#231F20"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M90 170.948C134.706 170.948 170.948 134.706 170.948 90C170.948 45.2935 134.706 9.05172 90 9.05172C45.2935 9.05172 9.05172 45.2935 9.05172 90C9.05172 134.706 45.2935 170.948 90 170.948ZM90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90C0 139.706 40.2944 180 90 180Z"
                      fill="url(#paint0_radial)"
                    ></path>
                    <path
                      d="M127.891 27.6302L129.085 18.1035L138.82 24.9612C138.656 26.4946 138.301 29.698 138.196 30.2451C138.065 30.929 136.685 34.0383 132.116 33.2585C128.461 32.6347 127.776 29.2463 127.891 27.6302Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M154.472 55.9039L159.267 47.5862L165.58 57.683C164.834 59.0327 163.265 61.8479 162.956 62.3114C162.569 62.8908 160.092 65.2215 156.183 62.7304C153.055 60.7375 153.739 57.349 154.472 55.9039Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M164.737 89.465L173.697 86.015L172.254 97.835C170.825 98.4151 167.834 99.6166 167.302 99.7826C166.637 99.99 163.245 100.244 161.773 95.8482C160.595 92.3319 163.258 90.1276 164.737 89.465Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M156.091 122.963L165.662 123.722L159.255 133.759C157.716 133.665 154.499 133.457 153.948 133.376C153.259 133.276 150.09 132.04 150.661 127.44C151.118 123.76 154.471 122.922 156.091 122.963Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M134.935 148.899L143.297 153.619L133.258 160.024C131.902 159.29 129.072 157.747 128.606 157.442C128.023 157.061 125.67 154.605 128.125 150.673C130.089 147.528 133.483 148.18 134.935 148.899Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M97.1543 162.729L101.305 171.387L89.4076 170.887C88.716 169.509 87.2807 166.623 87.0731 166.106C86.8135 165.46 86.2913 162.098 90.5559 160.282C93.9676 158.829 96.3764 161.308 97.1543 162.729Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M87.0254 16.9941L83 8L94.5729 8.53696C95.2438 9.96885 96.6359 12.9669 96.8371 13.5038C97.0887 14.175 97.5919 17.6653 93.4408 19.5446C90.1198 21.0481 87.7801 18.4707 87.0254 16.9941Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M127.891 27.6302L129.085 18.1035L138.82 24.9612C138.656 26.4946 138.301 29.698 138.196 30.2451C138.065 30.929 136.685 34.0383 132.116 33.2585C128.461 32.6347 127.776 29.2463 127.891 27.6302Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M52.2709 152.353L51.0769 161.879L41.3421 155.022C41.5062 153.488 41.8606 150.285 41.9657 149.738C42.097 149.054 43.4767 145.945 48.046 146.724C51.7014 147.348 52.3857 150.737 52.2709 152.353Z"
                      fill="#FDBC00"
                    ></path>
                    <path
                      d="M154.472 55.9039L159.267 47.5862L165.58 57.683C164.834 59.0327 163.265 61.8479 162.956 62.3114C162.569 62.8908 160.092 65.2215 156.183 62.7304C153.055 60.7375 153.739 57.349 154.472 55.9039Z"
                      fill="#FDBC00"
                    ></path>
                    <defs>
                      <radialGradient
                        id="paint0_radial"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(90 90) rotate(90) scale(90)"
                      >
                        <stop stop-color="#FAE100"></stop>
                        <stop offset="1" stop-color="#FF9800"></stop>
                      </radialGradient>
                    </defs>
                  </svg>
                </Box>
              </Box>
              <IconButton
                onClick={() => editor.chain().focus().toggleBold().run()}
              >
                <FormatBoldIcon sx={{ color: "text.primary" }} />
              </IconButton>
              <IconButton
                onClick={() => editor.chain().focus().toggleItalic().run()}
              >
                <FormatItalicIcon sx={{ color: "text.primary" }} />
              </IconButton>
              <IconButton
                onClick={() => editor.chain().focus().toggleUnderline().run()}
              >
                <FormatUnderlinedIcon sx={{ color: "text.primary" }} />
              </IconButton>
              <IconButton
                onClick={() => editor.chain().focus().toggleBulletList().run()}
              >
                <FormatListBulletedIcon sx={{ color: "text.primary" }} />
              </IconButton>
              <IconButton
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
              >
                <FormatListNumberedIcon sx={{ color: "text.primary" }} />
              </IconButton>
             {/* { <IconButton
                onClick={() =>
                  editor.chain().focus().setTextAlign("left").run()
                }
              >
                <FormatAlignLeftIcon sx={{ color: "text.primary" }} />
              </IconButton>
              <IconButton
                onClick={() =>
                  editor.chain().focus().setTextAlign("center").run()
                }
              >
              /Users/ujjawalsingh/Developer/untitled folder/msfa-frontend/msfa-dash/src/pages/Actyvai/Agreement.js
              /Users/ujjawalsingh/Developer/untitled folder/jkc-admin/src/pages/apps/banner/add/index.js
              /Users/ujjawalsingh/Developer/untitled folder/msfa-node/controllers/list.js
              /Users/ujjawalsingh/Developer/Applore/JKC-backend/JK-CONNECT-NODE/controllers/user/sapClaimsController.js
                <FormatAlignCenterIcon sx={{ color: "text.primary" }} />
              </IconButton>
              <IconButton
                onClick={() =>
                  editor.chain().focus().setTextAlign("right").run()
                }
              >
                <FormatAlignRightIcon sx={{ color: "text.primary" }} />
              </IconButton>} */}
              <IconButton
                onClick={() =>
                  addComment()
                }
              >
                <AddCommentIcon sx={{ color: "text.primary" }} />
              </IconButton>
            </Box>
            <Box mr={2}>

              <Button
                variant="contained"
                color="primary"
                sx={{ marginRight: 3 }}
                onClick={handleDrawerOpen}
              >
                Comments
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ marginRight: 3 }}
                onClick={()=>{setchangesopen(!changesopen);fetchchanges()}}
              >
                Changes
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={saveContent}
              >
                Save
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
        <Divider />
        <Box
          sx={{
            display: "flex",
           width:'100%',
            position: "relative",
            backgroundColor: "background.default",
          }}
        >
          <Box  >
            <Box
              sx={{
                display: "flex",
                flexGrow: 1,
                
                position: "relative",
                backgroundColor: "background.default",
              }}
            >
              <Grid>
              <Box
                sx={{
                  width: changesopen?(open?'80vh':'129vh'):(open?'120vh':'70%'),
                  flexGrow: 1,
                  transition: "margin 0.3s, width 0.3s",
                  marginRight: changesopen?(open? '50px':'20px' ):open ? `90px` : "-20px",
                  marginLeft: changesopen?(open ? `16px` : "20px" ):open ? `16px` : "250px",
                  marginTop: "20px",
                  marginBottom: "20px",
                  backgroundColor: "background.default",
                  overflow: "auto",
                }}
              >
                <Paper sx={{ height: "87vh", overflow: "auto", p: 7, boxShadow: 3 }}>
                  {editor && <EditorContent editor={editor} />}
                </Paper>
              </Box>
              </Grid>
              {open && (<Box sx={{ height: "100vh", overflow: "auto",width: '100%'}}>
              <Drawer
                sx={{
                  height:'90vh',
                  width: drawerWidth,
                  flexShrink: 0,
                  "& .MuiDrawer-paper": {
                    width: drawerWidth,
                    position: "relative",
                  },
                }}
                variant="persistent"
                anchor="right"
                open={open}
              >
                <Divider />
                <IconButton
                  sx={{ marginLeft: "auto" }}
                  onClick={handleDrawerClose}
                >
                  <Close />
                </IconButton>
                <List>
                  {allComments.map((comment, index) => (
                    <ListItem key={index} disablePadding>
                      <Paper sx={{ padding: 1, margin: 1, width: "100%" }}>
                        <Box display="flex" flexDirection="column">
                        <ListItemButton
                      key={index}
                      disablePadding
                      onClick={() => highlightLine(comment.line)}
                    >         
                        <Typography>Line: {comment.line}</Typography>

                               </ListItemButton>

                          <Typography>Comment: {comment.comment}</Typography>
                        </Box>
                      </Paper>
                    </ListItem>
                  ))}
                </List>
              </Drawer>
              </Box>)}
            </Box>
          </Box>
          {changesopen && (<Box sx={{ height: "100vh", overflow: "auto",width: '100%'}}>
          <Drawer
            sx={{
              height:'90vh',
              width: 332,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: 332,
                position: "relative",
              },
            }}
            variant="persistent"
            anchor="right"
            open={changesopen}
          >
            <Divider />
            <IconButton sx={{ marginLeft: "auto" }} onClick={()=>{setchangesopen(false)}}>
              <Close />
            </IconButton>
            <List>
             {changes.length>0? changes.map(( change,index) => (
                <ListItem key={index} disablePadding>
                  <Paper sx={{ padding: 2, margin: 1, width: "100%" }}>
                    <Box display="flex" flexDirection="column">
                      <Typography>{change}</Typography>
                    </Box>
                  </Paper>
                </ListItem>
              ))   :<Typography>no changes</Typography>}
            </List>
          </Drawer>
          </Box>)}
        </Box>
      </Box>

      <CommentDialogBox
      agreementid={agreementid}
        open={openCommentDialog}
        setopen={setOpenCommentDialog}
        setselectedText={setSelectedText}
        selectedText={selectedText}
        role={role}
        socket={socket}
        fetchcomment={fetchcomment}
      />
    </Box>
  );
};

export default Agreement;
